const DialogStyle = theme => ({
  modalRootTransparent: {
    backgroundColor: "transparent"
  },
  modalTransparent: {
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "hidden"
  },
  modalBodyTransparent: {
    background: "none",
    boxShadow: "none",
  },
});

export default DialogStyle;
